import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import axios from 'axios';

import Container from 'react-bootstrap/Container';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import {
    Table
    , Pagination
    , Loader
    , Button
    , IconButton
    , ButtonToolbar
    , Input
    , Tooltip
    , Whisper
    , Modal
    , VStack
    , Text
    , Form
    , InputGroup
    , AutoComplete
} from 'rsuite';

import Swal from 'sweetalert2'
import $ from 'jquery';

export default class UsersPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            authHeader: { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } },
            loading: false,
            content: null,
            modal: null,
            data: [],
            sortColumn: '',
            sortType: '',
            limit: 10,
            page: 1,
            password: '',
            confirm_password: '',
            changePassword: false,
            query: ''
        };
    }

    async componentDidMount() {
        await this.onRenderContent({ mode: 'read', query: '' })
    }

    promisedSetState = (newState) => {
        return new Promise(resolve => this.setState(newState, resolve));
    };

    handleSortColumn = async (sortColumn, sortType) => {
        await this.promisedSetState({ loading: true });

        await new Promise((resolve) => {
            setTimeout(() => {
                resolve();
            }, 500);
        });

        await this.promisedSetState({ loading: false });
        await this.promisedSetState({ sortColumn, sortType });

        // Call your onRenderContent function if needed
        await this.onRenderContent({ read: true, query: '' });
    };

    getData = async () => {
        if (this.state.sortColumn && this.state.sortType) {
            return this.state.data.sort((a, b) => {
                let x = a[this.state.sortColumn];
                let y = b[this.state.sortColumn];
                if (typeof x === 'string') {
                    x = x.charCodeAt();
                }
                if (typeof y === 'string') {
                    y = y.charCodeAt();
                }
                if (this.state.sortType === 'asc') {
                    return x - y;
                } else {
                    return y - x;
                }
            });
        }

        return this.state.data.filter((v, i) => {
            const start = this.state.limit * (this.state.page - 1);
            const end = start + this.state.limit;
            return i >= start && i < end;
        });
    };

    calculateAge = (date_of_birth) => {
        const birthDate = new Date(date_of_birth); // Convert birthdate to a Date object
        const today = new Date(); // Get today's date
        let age = today.getFullYear() - birthDate.getFullYear(); // Calculate the year difference

        // Check if the birthday has already occurred this year; if not, subtract 1
        const monthDiff = today.getMonth() - birthDate.getMonth();
        const dayDiff = today.getDate() - birthDate.getDate();

        if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
            age--; // Subtract 1 from age if birthday hasn't passed yet
        }

        return age;
    };

    handleSearch = () => {
        this.onRenderContent({ mode: 'read', query: this.state.query });
    };

    onRenderContent = async ({ mode, query }) => {
        if (mode === 'read') {
            try {
                const { Column, HeaderCell, Cell } = Table;

                await this.promisedSetState({ loading: true }); // Set loading state

                // Function to convert the Date to Thai format
                const convertToThaiDate = (dateString) => {
                    const monthsInThai = [
                        'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
                        'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
                    ];

                    const date = new Date(dateString);
                    const day = date.getDate();
                    const month = monthsInThai[date.getMonth()];
                    const year = date.getFullYear() + 543; // Convert from Gregorian to Thai Buddhist year
                    const hours = String(date.getHours()).padStart(2, '0');
                    const minutes = String(date.getMinutes()).padStart(2, '0');
                    const seconds = String(date.getSeconds()).padStart(2, '0');

                    return `วันที่ ${day} ${month} ${year} เวลา ${hours}:${minutes}:${seconds}`;
                };

                const responseAPI = await axios.post(`${process.env.REACT_APP_API}/applicants/filter`, { query: query }, this.state.authHeader);
                const data = responseAPI.data.map((res, index) => ({
                    index: index + 1,
                    id: res.id,
                    prefix: res.prefix,
                    name: `${res.first_name} ${res.last_name}`,
                    age: this.calculateAge(res.date_of_birth),
                    phone: res.phone,
                    email: res.email,
                    latest_access: convertToThaiDate(res.latest_access)
                }));

                await this.promisedSetState({ data: data });

                const paginatedData = await this.getData();

                const autoComplete = responseAPI.data.map((res) => [
                    res.first_name,
                    res.last_name,
                    res.province,
                    res.email
                ]);

                const flatAutoComplete = autoComplete.flat();

                const uniqueFlatAutoComplete = [...new Set(flatAutoComplete)];

                await this.promisedSetState({
                    content: <><Row className='mt-3'>
                        <Col>
                            <Breadcrumb size='lg' >
                                <Breadcrumb.Item><Link to="/admin"><i className="bi bi-house-fill"></i></Link></Breadcrumb.Item>
                                <Breadcrumb.Item active>ผู้สมัครเข้าใช้งานระบบ (Users)</Breadcrumb.Item>
                            </Breadcrumb>
                        </Col>
                    </Row>
                        <Row className='mb-2'>
                            <Col>
                                <Text weight='bold'><i className="bi bi-people-fill"></i>{' '}รายชื่อผู้สมัครขอรับทุนการศึกษา</Text>
                            </Col>
                        </Row>

                        <Row className='mb-2'>
                            <Col xs={24} md={12} lg={8}>
                                <InputGroup style={{ width: '100%' }}>

                                    <InputGroup.Button tabIndex={-1}>
                                        <i className="bi bi-search"></i>
                                    </InputGroup.Button>

                                    <div style={{ flex: 1 }}>
                                        <AutoComplete
                                            data={uniqueFlatAutoComplete}
                                            defaultValue={this.state.query}
                                            onChange={value => this.setState({ query: value })}
                                            style={{ width: '100%' }}
                                        />
                                    </div>

                                    <InputGroup.Button onClick={this.handleSearch}>
                                        ค้นหา
                                    </InputGroup.Button>

                                </InputGroup>
                            </Col>
                        </Row>

                        <Row className='mb-3'>
                            <Col>
                                <Table
                                    autoHeight
                                    data={paginatedData}
                                    bordered
                                    cellBordered
                                    sortColumn={this.state.sortColumn}
                                    sortType={this.state.sortType}
                                    onSortColumn={async (sortColumn, sortType) => {
                                        await this.handleSortColumn(sortColumn, sortType);
                                    }}
                                    className='shadow-sm'
                                >
                                    <Column width={60} align="center">
                                        <HeaderCell>ลำดับ</HeaderCell>
                                        <Cell dataKey="index" />
                                    </Column>

                                    <Column width={110} sortable>
                                        <HeaderCell>คำนำหน้า</HeaderCell>
                                        <Cell dataKey="prefix" />
                                    </Column>

                                    <Column width={240} sortable>
                                        <HeaderCell>ชื่อ - นามสกุล</HeaderCell>
                                        <Cell dataKey="name" />
                                    </Column>

                                    <Column width={100} sortable>
                                        <HeaderCell>อายุ (ปี)</HeaderCell>
                                        <Cell dataKey="age" />
                                    </Column>

                                    <Column width={180} sortable>
                                        <HeaderCell>เบอร์โทรศัพท์</HeaderCell>
                                        <Cell dataKey="phone" />
                                    </Column>

                                    <Column width={220} sortable>
                                        <HeaderCell>E-mail</HeaderCell>
                                        <Cell dataKey="email" />
                                    </Column>

                                    <Column width={285} sortable>
                                        <HeaderCell>วันที่และเวลา เข้าระบบล่าสุด</HeaderCell>
                                        <Cell dataKey="latest_access" />
                                    </Column>

                                    <Column width={100} align='center' fixed="right">
                                        <HeaderCell>...</HeaderCell>

                                        <Cell style={{ padding: '6px' }}>
                                            {rowData => (
                                                <ButtonToolbar>
                                                    <Whisper followCursor speaker={<Tooltip>แก้ไข</Tooltip>}>
                                                        <IconButton size='sm'
                                                            color="yellow"
                                                            appearance="primary"
                                                            icon={<i className="bi bi-pencil-square"></i>}
                                                            onClick={async () => {
                                                                await this.promisedSetState({ changePassword: false, password: '', confirm_password: '' })
                                                                await this.onModal({ mode: 'update', id: rowData.id })
                                                            }}
                                                        />
                                                    </Whisper>
                                                    <Whisper followCursor speaker={<Tooltip>ลบ</Tooltip>}>
                                                        <IconButton size='sm'
                                                            color="red"
                                                            appearance="primary"
                                                            icon={<i className="bi bi-trash-fill"></i>}
                                                            onClick={() => this.onConfirm({ mode: 'delete', id: rowData.id })}
                                                        />
                                                    </Whisper>
                                                </ButtonToolbar>
                                            )}
                                        </Cell>
                                    </Column>
                                </Table>

                                {data.length === 0 && (
                                    <p>ไม่มีข้อมูล</p> // Informative message when no data is found
                                )}

                                <div style={{ padding: 20 }}>
                                    <Pagination
                                        prev
                                        next
                                        first
                                        last
                                        ellipsis
                                        boundaryLinks
                                        maxButtons={5}
                                        size="xs"
                                        layout={['total', '|', 'pager']}
                                        total={data.length}
                                        limit={this.state.limit}
                                        activePage={this.state.page}
                                        onChangePage={async (e) => {
                                            await this.promisedSetState({ page: e }); // Update current page
                                            await this.onRenderContent({ mode: 'read', query: '' }); // Fetch new data based on page
                                        }}
                                    />
                                </div>
                            </Col>
                        </Row></>
                })
            } catch (error) {
                console.error('API request failed:', error);
                // Consider adding user feedback here
            } finally {
                await this.promisedSetState({ loading: false }); // Reset loading state
            }
        }
    }

    visiblePassword = async (obj) => {
        try {
            if (obj.type === 'password') {
                console.log('Toggling password visibility');
                await this.promisedSetState({ visiblePassword: !this.state.visiblePassword });
                this.onModal({ mode: obj.mode, id: obj.id, visible: true })
            } else if (obj.type === 'confirm_password') {
                console.log('Toggling confirm password visibility');
                await this.promisedSetState({ visibleCpassword: !this.state.visibleCpassword });
                this.onModal({ mode: obj.mode, id: obj.id, visible: true })
            }
            console.log('Updated state:', this.state);
        } catch (error) {
            console.error('Error in visiblePassword:', error);
        }
    }

    handleChangePassword = async ({ mode, id }) => {
        await this.promisedSetState({ changePassword: true });
        await this.onModal({ mode, id })
    };

    onModal = async ({ mode, id }) => {
        if (mode === 'update') {

            const { data } = await axios.get(`${process.env.REACT_APP_API}/applicants/${id}`, this.state.authHeader);
            const applicants = data[0];  // Assuming `data` is an array

            await this.promisedSetState({
                modal: <Modal backdrop={'static'}
                    keyboard={false}
                    open={true}
                    onClose={() => this.setState({ modal: null })}
                >
                    <Modal.Header>
                        <Modal.Title>แก้ไขผู้สมัครขอรับทุนการศึกษา</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Container>
                            <Row className='mb-3'>
                                <Col>
                                    <VStack>
                                        <label>ชื่อ - นามสกุล</label>
                                        <Input
                                            size='sm'
                                            defaultValue={`${applicants.first_name} ${applicants.last_name}`}
                                            readOnly={true}
                                        />
                                    </VStack>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <VStack>
                                        <label>E-mail</label>
                                        <Input
                                            size='sm'
                                            defaultValue={applicants.email}
                                            readOnly={true}
                                        />
                                    </VStack>
                                </Col>
                            </Row>

                            {!this.state.changePassword && (<Row className='mt-3'>
                                <Col sm>
                                    <Button startIcon={<i class="bi bi-key-fill"></i>}
                                        color="red"
                                        appearance="primary"
                                        onClick={e => this.handleChangePassword({ event: e, mode: mode, id: id })}
                                    >
                                        เปลี่ยนรหัสผ่าน
                                    </Button>
                                </Col>
                            </Row>
                            )}

                            {this.state.changePassword && <><Row className='mt-3'>
                                <Col sm>
                                    <Form.Group>
                                        <Form.ControlLabel><b>Password</b>{' '}<b className='text-danger'>*</b></Form.ControlLabel>
                                        <InputGroup inside >
                                            <Input
                                                className='7OfXZ'
                                                defaultValue={this.state.password}
                                                type={this.state.visiblePassword ? 'text' : 'password'}
                                                onChange={(e) => this.setState({ password: e })}
                                            />
                                            <InputGroup.Button onClick={async () => {
                                                await this.visiblePassword({ type: 'password', mode: mode, id: id })
                                                await this.onModal({ mode: mode, id: id })
                                            }}>
                                                {this.state.visiblePassword ? <i className="bi bi-eye-fill"></i> : <i className="bi bi-eye-slash-fill"></i>}
                                            </InputGroup.Button>
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                            </Row>

                                <Row className='mt-3'>
                                    <Col sm>
                                        <Form.Group>
                                            <Form.ControlLabel><b>Confirm Password</b>{' '}<b className='text-danger'>*</b></Form.ControlLabel>
                                            <InputGroup inside >
                                                <Input
                                                    className='WOOVZ'
                                                    defaultValue={this.state.confirm_password}
                                                    type={this.state.visibleCpassword ? 'text' : 'password'}
                                                    onChange={(e) => this.setState({ confirm_password: e })}
                                                />
                                                <InputGroup.Button onClick={async () => {
                                                    await this.visiblePassword({ type: 'confirm_password', mode: mode, id: id })
                                                    await this.onModal({ mode: mode, id: id })
                                                }}>
                                                    {this.state.visibleCpassword ? <i class="bi bi-eye-fill"></i> : <i class="bi bi-eye-slash-fill"></i>}
                                                </InputGroup.Button>
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                </Row></>}

                        </Container>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button size='sm'
                            startIcon={<i className="bi bi-floppy"></i>}
                            appearance="primary"
                            onClick={() => this.onConfirm({ mode: 'update', id: id })}>
                            บันทึก
                        </Button>
                        <Button size='sm'
                            appearance="subtle"
                            onClick={() => this.setState({ modal: null })}>
                            ยกเลิก
                        </Button>
                    </Modal.Footer>
                </Modal>
            })
        }
    }

    // Function to validate a password
    validatePassword = (password) => {
        const minLength = 6;
        const maxLength = 18;
        const hasNumber = /\d/;
        const hasSymbol = /[!@#$%^&*(),.?":{}|<>]/;
        const isEnglishOnly = /^[A-Za-z0-9!@#$%^&*(),.?":{}|<>]+$/;

        if (password.length < minLength || password.length > maxLength) {
            return { valid: false, message: "รหัสผ่านต้องมีความยาวระหว่าง 6 ถึง 18 ตัวอักษร" };
        }
        if (!hasNumber.test(password)) {
            return { valid: false, message: "รหัสผ่านต้องมีหมายเลข\nอย่างน้อยหนึ่งตัว" };
        }
        if (!hasSymbol.test(password)) {
            return { valid: false, message: "รหัสผ่านต้องมีสัญลักษณ์\nอย่างน้อยหนึ่งตัว" };
        }
        if (!isEnglishOnly.test(password)) {
            return { valid: false, message: "รหัสผ่านสามารถประกอบด้วย\nตัวอักษรภาษาอังกฤษ ตัวเลข และสัญลักษณ์เท่านั้น" };
        }
        return { valid: true };
    };

    Validate = async (params, clss, cond) => {
        try {
            // Simulate an asynchronous operation (e.g., a network request or delay)
            await new Promise(resolve => setTimeout(resolve, 100)); // Simulating a 500ms delay

            if (params == cond) {
                // Add 'required' class if condition is met
                $('.' + clss).addClass("required");

                // Display an alert using SweetAlert
                Swal.fire({
                    title: "กรุณากรอกข้อมูลให้ครบถ้วน",
                    icon: "warning",
                    timer: 2000,
                    timerProgressBar: true,
                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                });

                return false; // Return false if validation fails
            } else if (params != cond) {
                // Remove 'required' class if condition is not met
                $('.' + clss).removeClass("required");

                return true; // Return true if validation passes
            }
        } catch (error) {
            console.error('Validation error:', error);
            return false; // If something goes wrong, return false as fallback
        }
    };

    onConfirm = async ({ mode, id }) => {

        const validate = async () => {
            // Start with an array to collect validation promises
            const validationPromises = [
                ...(this.state.changePassword === true ? [
                    this.Validate(this.state.password, '7OfXZ', ''),
                    this.Validate(this.state.confirm_password, 'WOOVZ', ''),
                ] : []),
            ];

            // Wait for all validation promises to resolve
            const validationResults = await Promise.all(validationPromises);

            // Return true if all validations are successful (i.e., all are true)
            return validationResults.every(result => result === true);
        };

        if (mode === 'update') {

            if (this.state.changePassword === true) {

                if (await validate()) {

                    try {
                        this.checkpass = true;

                        // Validate password with the new function
                        const passwordValidation = this.validatePassword(this.state.password);
                        if (!passwordValidation.valid) {
                            $('.7OfXZ').addClass("required");
                            Swal.fire({
                                title: passwordValidation.message,
                                icon: "warning",
                                timer: 2000,
                                timerProgressBar: true,
                                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                            });
                            this.checkpass = this.checkpass && false;
                        } else {
                            $('.7OfXZ').removeClass("required");
                        }

                        // Validate confirm password
                        if (this.state.password !== this.state.confirm_password) {
                            $('.WOOVZ').addClass("required");
                            Swal.fire({
                                title: "รหัสผ่านไม่ตรงกัน",
                                icon: "warning",
                                timer: 2000,
                                timerProgressBar: true,
                                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                            });
                            this.checkpass = this.checkpass && false;
                        } else {
                            $('.WOOVZ').removeClass("required");
                        }

                        if (this.checkpass === true) {
                            const Response = await axios.put(`${process.env.REACT_APP_API}/applicants/password`, {
                                id: id,
                                password: this.state.password
                            }, this.state.authHeader);

                            const data = Response.data;

                            if (data.message === 'successfully') {
                                await this.onRenderContent({ mode: 'read', query: '' })

                                await this.promisedSetState({ modal: null })

                                Swal.fire({
                                    title: "คุณแก้ไขข้อมูลเรียบร้อยแล้ว",
                                    icon: "success",
                                    timer: 2000,
                                    timerProgressBar: true,
                                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                                });
                            }
                        }
                    } catch (error) {
                        console.log(error)
                    }
                }
            } else if (this.state.changePassword === false) {

                await this.onRenderContent({ mode: 'read', query: '' })

                await this.promisedSetState({ modal: null })
            }

        } else if (mode === 'delete') {
            Swal.fire({
                title: "คุณต้องการลบใช่หรือไม่?",
                icon: "warning",
                showDenyButton: true,
                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                denyButtonText: `<div style="font-size: 1.425rem">ยกเลิก</div>`,
            }).then(async (result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {

                    const Response = await axios.delete(`${process.env.REACT_APP_API}/applicants/${id}`, this.state.authHeader);

                    const data = Response.data;

                    if (data.message === 'successfully') {

                        await this.onRenderContent({ mode: 'read', query: '' })

                        Swal.fire({
                            title: "คุณลบข้อมูลเรียบร้อยแล้ว",
                            icon: "success",
                            timer: 2000,
                            timerProgressBar: true,
                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                        });
                    }
                } else if (result.isDenied) {

                    await this.onRenderContent({ mode: 'read', query: '' })
                }
            });
        }
    }

    render() {

        const FullPageLoader = () => (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.8)', // Semi-transparent background
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999 // Ensure it's on top of other content
            }}>
                <Loader content="Loading..." /> {/* Adjust loader component as needed */}
            </div>
        );

        return (
            <>
                {this.state.content}
                {this.state.modal}
                {this.state.loading && <FullPageLoader />}
            </>
        );
    }
}
